import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '@/lib/api';
import { getBusinessTypeConfig } from '@/lib/business-type-config';

const BusinessTypeContext = createContext(null);

export function BusinessTypeProvider({ children }) {
  const [businessType, setBusinessType] = useState('restaurant');
  const [config, setConfig] = useState(getBusinessTypeConfig('restaurant'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBusinessType();
  }, []);

  const fetchBusinessType = async () => {
    try {
      const res = await api.get('/vendor/profile');
      const type = res.data.business_type || 'restaurant';
      setBusinessType(type);
      setConfig(getBusinessTypeConfig(type));
    } catch (err) {
      console.warn('Failed to fetch business type, defaulting to restaurant:', err);
      setConfig(getBusinessTypeConfig('restaurant'));
    } finally {
      setLoading(false);
    }
  };

  const updateBusinessType = (newType) => {
    setBusinessType(newType);
    setConfig(getBusinessTypeConfig(newType));
  };

  return (
    <BusinessTypeContext.Provider value={{ businessType, config, loading, updateBusinessType }}>
      {children}
    </BusinessTypeContext.Provider>
  );
}

export function useBusinessType() {
  const context = useContext(BusinessTypeContext);
  if (!context) {
    throw new Error('useBusinessType must be used within BusinessTypeProvider');
  }
  return context;
}
